import React from "react";
import {Card} from "react-bootstrap";

import ProjectOverview from "./ProjectOverview";

export default function Sidebar(props) {

    return (
        <div className={props.className}>

            <h6>Precursors</h6>
            <ProjectOverview/>

            <div className="pt-3">
                <h6>Graph</h6>
                <Card>
                    <Card.Body>
                        <div style={{width: "100%", paddingBottom: "100%"}}/>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}
